module.exports = __webpack_public_path__ + "static/media/step2.007c3236.png";